import React, { useState } from 'react';
import { useReveal } from '../lib/useReveal';
const TOMOS = [{
  num: '01',
  title: 'Fundamentos de Biodescodificación',
  summary: 'El vínculo entre emoción, biología y síntoma.',
  content: 'Origen, principios del método y una base clara para iniciar el recorrido con criterio profesional.'
}, {
  num: '02',
  title: 'El Mapa del Síntoma',
  summary: 'Lectura emocional de los sistemas del cuerpo.',
  content: 'Lateralidad, ubicación, tiempo del síntoma y referencias prácticas para ampliar tu observación.'
}, {
  num: '03',
  title: 'Transgeneracional y Árbol Bio',
  summary: 'Patrones familiares, lealtades y repeticiones.',
  content: 'Una guía para detectar dinámicas heredadas y construir una lectura ordenada del árbol familiar.'
}, {
  num: '04',
  title: 'Protocolos de Sesión',
  summary: 'Estructura para acompañar procesos paso a paso.',
  content: 'Apertura, exploración, integración y cierre de una sesión con herramientas claras y seguras.'
}, {
  num: '05',
  title: 'Casos Clínicos Reales',
  summary: 'Aplicación práctica en situaciones concretas.',
  content: 'Casos analizados para comprender la conexión entre hipótesis, preguntas y proceso terapéutico.'
}, {
  num: '06',
  title: 'Tu Consultorio Holístico Profesional',
  summary: 'Organizá una práctica coherente y profesional.',
  content: 'Recursos para sesiones, atención online, comunicación y organización de tu actividad.'
}];
export function SystemSection() {
  const [ref, visible] = useReveal();
  const [openTomo, setOpenTomo] = useState<string | null>(null);
  return <section className="border-t border-[#2E4F48]/15 bg-[#EFEAE0] px-4 py-10 sm:px-6 md:py-16" data-id="element-326" data-mp="1ctmah5dj5l5v">
      <div ref={ref} className={`reveal container mx-auto max-w-6xl ${visible ? 'is-visible' : ''}`} data-id="element-327" data-mp="1hspimyot47i2">
        <div className="mx-auto mb-7 max-w-2xl text-center" data-id="element-328" data-mp="6b7mak9k2a5k">
          <p className="text-xs font-bold tracking-[0.2em] text-[#C2683D]" data-id="element-329" data-mp="6cr2ybz4in7v">PROGRAMA DE ESTUDIO</p>
          <h2 className="mt-3 font-serif text-3xl font-bold leading-tight text-[#1C3B36] md:text-5xl" data-id="element-330" data-mp="28xbjx6zjdbf0">
            ¿Qué aprenderás durante la formación?
          </h2>
        </div>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-331" data-mp="1z70fljbxx07l">
          {TOMOS.map(tomo => {
          const isOpen = openTomo === tomo.num;
          return <article key={tomo.num} className="rounded-2xl border border-[#2E4F48]/20 bg-white p-5 shadow-sm" data-id="element-332" data-mp="1padxh2b00n99">
                <span className="text-xs font-bold tracking-[0.18em] text-[#C2683D]" data-id="element-333" data-mp="1lawqu5ju5k2i">TOMO {tomo.num}</span>
                <h3 className="mt-2 min-h-[3.4rem] font-serif text-xl font-bold leading-tight text-[#1C3B36]" data-id="element-334" data-mp="1backiohglpdf">
                  {tomo.title}
                </h3>
                <p className="mt-3 min-h-[2.8rem] text-sm leading-relaxed text-[#44574F]" data-id="element-335" data-mp="3amykdb035030">
                  {tomo.summary}
                </p>
                <button type="button" onClick={() => setOpenTomo(isOpen ? null : tomo.num)} aria-expanded={isOpen} className="mt-5 text-sm font-bold text-[#C2683D] underline-offset-4 hover:underline" data-id="element-336" data-mp="3d86aojb60zgl">
                  {isOpen ? 'Ocultar contenido' : 'Ver contenido'}
                </button>
                {isOpen && <p className="mt-3 border-t border-[#2E4F48]/15 pt-3 text-sm leading-relaxed text-[#1C3B36]" data-id="element-337" data-mp="2u9k78xs6ew9i">
                    {tomo.content}
                  </p>}
              </article>;
        })}
        </div>
      </div>
    </section>;
}